(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1698],{

/***/ 24931:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/careers",
      function () {
        return __webpack_require__(14066);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 92661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Radio__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45993);
/* harmony import */ var _mui_material_RadioGroup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68061);
/* harmony import */ var _mui_material_FormControlLabel__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20847);
/* harmony import */ var components_icons_RadioCheckedIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81440);
/* harmony import */ var components_icons_RadioIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10604);
/* harmony import */ var _RadioButton_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93636);
/* harmony import */ var _RadioButton_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_RadioButton_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var components_text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22538);









var RadioButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function RadioButtonWithRef(param, ref) {
    var name = param.name, value = param.value, options = param.options, onRadioButtonClick = param.onRadioButtonClick, errorMsg = param.errorMsg, className = param.className;
    var handleChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        onRadioButtonClick(name, value);
    }, [
        name,
        onRadioButtonClick
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_RadioGroup__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                ref: ref,
                "aria-labelledby": "radio-buttons-group-label",
                name: "radio-buttons-group",
                value: value !== null && value !== void 0 ? value : "",
                onChange: function(e) {
                    return handleChange(e.target.value);
                },
                className: (_RadioButton_module_scss__WEBPACK_IMPORTED_MODULE_6___default().radioContainer),
                children: options.map(function(option) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_FormControlLabel__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        className: "".concat((_RadioButton_module_scss__WEBPACK_IMPORTED_MODULE_6___default().radioButton), " ").concat(errorMsg && (_RadioButton_module_scss__WEBPACK_IMPORTED_MODULE_6___default().error)),
                        value: option.value,
                        control: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Radio__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_icons_RadioIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
                            checkedIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_icons_RadioCheckedIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
                        }),
                        label: option.label
                    }, option.value);
                })
            }),
            errorMsg && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_text__WEBPACK_IMPORTED_MODULE_4__/* .Body */ .uT, {
                color: "forms-red",
                children: errorMsg
            })
        ]
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (RadioButton);


/***/ }),

/***/ 80434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Select; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js
var Button = __webpack_require__(69397);
// EXTERNAL MODULE: ./node_modules/@mui/material/Menu/Menu.js
var Menu = __webpack_require__(24486);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(63931);
;// CONCATENATED MODULE: ./hooks/useBodyScrollLock.ts

var useBodyScrollLock = function() {
    var originalPaddingRight = (0,react.useRef)(null);
    var originalTop = (0,react.useRef)(0);
    var isLocked = (0,react.useRef)(false);
    var disableScroll = function() {
        if (false) {}
        // Check if body already has overflow hidden
        if (window.getComputedStyle(document.body).overflow === "hidden") {
            isLocked.current = false; // Indicate that the hook didn't lock the scroll
            return;
        }
        // Save the current scroll position
        originalTop.current = window.scrollY;
        // Add padding to prevent layout shift due to scrollbar disappearance
        var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
        originalPaddingRight.current = document.body.style.paddingRight;
        if (scrollBarGap > 0) {
            document.body.style.paddingRight = "".concat(scrollBarGap, "px");
        }
        // Lock scroll using `position: fixed` and save the scroll offset in `top`
        document.body.style.position = "fixed";
        document.body.style.top = "-".concat(originalTop.current, "px");
        document.body.style.left = "0";
        document.body.style.width = "100%";
        isLocked.current = true;
    };
    var enableScroll = function() {
        if ( false || !isLocked.current) return;
        // Get the original scroll position from the `top` property
        var scrollY = Math.abs(parseInt(document.body.style.top || "0", 10));
        // Temporarily disable scroll animation
        var originalScrollBehavior = document.documentElement.style.scrollBehavior;
        document.documentElement.style.scrollBehavior = "auto";
        // Restore original styles
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.left = "";
        document.body.style.width = "";
        if (originalPaddingRight.current !== null) {
            document.body.style.paddingRight = originalPaddingRight.current;
        }
        // Restore the scroll position without animation
        window.scrollTo(0, scrollY);
        // Restore the original scroll-behavior
        document.documentElement.style.scrollBehavior = originalScrollBehavior || "";
        isLocked.current = false;
    };
    return {
        disableScroll: disableScroll,
        enableScroll: enableScroll
    };
};
/* harmony default export */ var hooks_useBodyScrollLock = (useBodyScrollLock);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/icons/ArrowDown.tsx
var ArrowDown = __webpack_require__(91441);
// EXTERNAL MODULE: ./components/icons/ArrowUp.tsx
var ArrowUp = __webpack_require__(29661);
;// CONCATENATED MODULE: ./components/Select/Select.tsx










function Select(param) {
    var label = param.label, value = param.value, name = param.name, options = param.options, onChange = param.onChange, _upperCaseOptions = param.upperCaseOptions, upperCaseOptions = _upperCaseOptions === void 0 ? false : _upperCaseOptions, _layout = param.layout, layout = _layout === void 0 ? "FORM" : _layout;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), anchorEl = ref[0], setAnchorEl = ref[1];
    var ref1 = hooks_useBodyScrollLock(), disableScroll = ref1.disableScroll, enableScroll = ref1.enableScroll;
    var open = Boolean(anchorEl);
    var handleMenuOpen = function(event) {
        setAnchorEl(event.currentTarget);
        disableScroll();
    };
    var handleClose = function() {
        setAnchorEl(null);
        enableScroll();
    };
    var handleSelect = function(selectedValue) {
        onChange(name, selectedValue);
        handleClose();
    };
    var getPresentedValue = function() {
        var selectedOption = options.find(function(option) {
            return option.value === value;
        });
        return (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.name) || (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.html) || value;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "select-container".concat(open ? " select-container--open" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "select-container__label",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                id: "basic-button",
                disableRipple: true,
                className: classnames_default()({
                    "form-layout": layout === "FORM",
                    "currency-layout": layout === "CURRENCY"
                }),
                onClick: handleMenuOpen,
                endIcon: open ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUp/* default */.Z, {
                    width: 12,
                    height: 6
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                    width: 12,
                    height: 6
                }),
                children: getPresentedValue()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                MenuListProps: {
                    sx: {
                        borderTop: "1px solid #000",
                        minWidth: "140px"
                    }
                },
                children: options.map(function(option) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                        disableRipple: true,
                        selected: option.value === value,
                        onClick: function() {
                            return handleSelect(option.value);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                textTransform: upperCaseOptions ? "uppercase" : "none"
                            },
                            children: option.name || option.html || option.value
                        })
                    }, option.value);
                })
            })
        ]
    });
}


/***/ }),

/***/ 91441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




var ArrowDown = function(_param) {
    var _width = _param.width, width = _width === void 0 ? 17 : _width, _height = _param.height, height = _height === void 0 ? 9 : _height, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "width",
        "height"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: width,
        height: height,
        viewBox: "0 0 17 9",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M16.1336 1.08877L15.414 0.369143L8.45778 7.32531L1.50161 0.369141L0.781982 1.08877L8.45778 8.76457L16.1336 1.08877Z",
            fill: "#191919"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ArrowDown);


/***/ }),

/***/ 29661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




var ArrowUp = function(_param) {
    var _width = _param.width, width = _width === void 0 ? 17 : _width, _height = _param.height, height = _height === void 0 ? 10 : _height, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "width",
        "height"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: width,
        height: height,
        viewBox: "0 0 17 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M0.792202 8.65561L1.51183 9.37524L8.468 2.41907L15.4242 9.37524L16.1438 8.65562L8.468 0.979815L0.792202 8.65561Z",
            fill: "#191919"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ArrowUp);


/***/ }),

/***/ 81440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var RadioCheckedIcon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "15",
                cy: "15",
                r: "14.5",
                fill: "white",
                stroke: "#B2B2B2"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "15",
                cy: "15",
                r: "8",
                fill: "#505050"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (RadioCheckedIcon);


/***/ }),

/***/ 10604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var RadioIcon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
            cx: "15",
            cy: "15",
            r: "14.5",
            fill: "white",
            stroke: "#B2B2B2"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (RadioIcon);


/***/ }),

/***/ 14066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ careers; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./data/translationKeys.ts
var translationKeys = __webpack_require__(698);
// EXTERNAL MODULE: ./customHooks/useLocalised/useLocalised.ts + 2 modules
var useLocalised = __webpack_require__(91933);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
// EXTERNAL MODULE: ./services/ValidationService/ValidationService.ts
var ValidationService = __webpack_require__(91306);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./services/WebService/WebService.ts
var WebService = __webpack_require__(55840);
// EXTERNAL MODULE: ./data/constants.ts
var constants = __webpack_require__(84749);
;// CONCATENATED MODULE: ./services/CareerService/CareerService.ts





var CareerService = /*#__PURE__*/ function() {
    "use strict";
    function CareerService() {
        (0,_class_call_check/* default */.Z)(this, CareerService);
    }
    CareerService.getCareers = function getCareers() {
        return (0,_async_to_generator/* default */.Z)(function() {
            var option, careers, feCareersList, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        option = new WebService/* ServerWebServiceOption */.iO("GET", constants/* webserviceEndpoints.LE_CAREERS */.fX.LE_CAREERS);
                        return [
                            4,
                            WebService/* default.shared */.ZP.shared().callWebService(option)
                        ];
                    case 1:
                        careers = _state.sent();
                        feCareersList = careers.map(function(param) {
                            var id = param.id, title = param.title, intro_to_role = param.intro_to_role, sub_title_1 = param.sub_title_1, sub_title_2 = param.sub_title_2, summary1 = param.summary1, summary2 = param.summary2, contact = param.contact, display_order = param.display_order, form = param.form, location = param.location;
                            return {
                                id: id,
                                name: title,
                                location: location,
                                introduction: intro_to_role,
                                subheading: sub_title_1,
                                description: CareerService.getNormalizedRequirement(summary1),
                                secondSubheading: sub_title_2,
                                requirements: CareerService.getNormalizedRequirement(summary2),
                                contact: contact,
                                hasForm: form,
                                displayOrder: display_order
                            };
                        });
                        return [
                            2,
                            feCareersList.sort(function(param, param1) {
                                var a = param.displayOrder, b = param1.displayOrder;
                                return a - b;
                            })
                        ];
                    case 2:
                        error = _state.sent();
                        throw error;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    CareerService.getNormalizedRequirement = function getNormalizedRequirement(requirement) {
        return requirement.replaceAll("\r\n", "<br />");
    };
    CareerService.sendJobApplication = function sendJobApplication(jobApplication) {
        return new Promise(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(resolve, reject) {
                var option, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            option = new WebService/* ClientWebServiceOption */.J_("POST", constants/* webserviceEndpoints.FAKE */.fX.FAKE, jobApplication);
                            return [
                                4,
                                WebService/* default.shared */.ZP.shared().callWebService(option)
                            ];
                        case 1:
                            _state.sent();
                            resolve();
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            reject();
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(resolve, reject) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    return CareerService;
}();
/* harmony default export */ var CareerService_CareerService = (CareerService);

// EXTERNAL MODULE: ./components/TextField/TextField.tsx
var TextField = __webpack_require__(90943);
// EXTERNAL MODULE: ./components/Select/Select.tsx + 1 modules
var Select = __webpack_require__(80434);
// EXTERNAL MODULE: ./components/RadioButton/RadioButton.tsx
var RadioButton = __webpack_require__(92661);
;// CONCATENATED MODULE: ./blocks/CareerListSection/components/CareerForm.tsx















var initialCareersState = {
    isLoading: false,
    success: false,
    name: "",
    email: "",
    phoneNumber: "",
    country: "",
    comment: "",
    experince: "experienced",
    errors: {
        name: false,
        email: false,
        phoneNumber: false,
        country: false
    }
};
var ORDERED_FIELD_KEYS = [
    "name",
    "phoneNumber",
    "email", 
];
var CareerForm = function(param) {
    var countryCodes = param.countryCodes;
    var ref = (0,react.useState)(initialCareersState), state = ref[0], setState = ref[1];
    var userInputRefs = (0,react.useRef)({});
    var giveRef = (0,react.useCallback)(function(instance, inputName) {
        userInputRefs.current = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, userInputRefs.current), (0,_define_property/* default */.Z)({}, inputName, instance));
    }, []);
    var handleScrollToError = (0,react.useCallback)(function(errorObject) {
        var scrollHandled = false;
        var index = 0;
        while(index < ORDERED_FIELD_KEYS.length && scrollHandled === false){
            var key = ORDERED_FIELD_KEYS[index];
            if (errorObject[key] && userInputRefs.current[key]) {
                var ref;
                (ref = userInputRefs.current[key]) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                    behavior: "smooth"
                });
                scrollHandled = true;
            }
            index += 1;
        }
    }, []);
    var formIsValid = (0,react.useCallback)(function() {
        var isValid = true;
        var errorObject = {};
        if (!ValidationService/* default.isValidEmail */.Z.isValidEmail(state.email)) {
            isValid = false;
            errorObject = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, errorObject), {
                email: true
            });
        }
        if (!ValidationService/* default.isValidName */.Z.isValidName(state.name)) {
            isValid = false;
            errorObject = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, errorObject), {
                name: true
            });
        }
        if (!ValidationService/* default.isValidPhoneNumber */.Z.isValidPhoneNumber(state.phoneNumber)) {
            isValid = false;
            errorObject = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, errorObject), {
                phoneNumber: true
            });
        }
        if (!ValidationService/* default.isValidCountryCode */.Z.isValidCountryCode(state.country)) {
            isValid = false;
            errorObject = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, errorObject), {
                countryCode: true
            });
        }
        if (!isValid) {
            handleScrollToError(errorObject);
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    errors: (0,_object_spread/* default */.Z)({}, state.errors, errorObject)
                });
            });
        }
        return isValid;
    }, [
        handleScrollToError,
        state.country,
        state.email,
        state.name,
        state.phoneNumber
    ]);
    var handleTextChange = (0,react.useCallback)(function(e) {
        var key = e.target.name;
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({
                errors: (0,_object_spread/* default */.Z)({}, initialCareersState.errors)
            }, key, e.target.value));
        });
    }, []);
    var handleSelectChange = (0,react.useCallback)(function(name, value) {
        var key = name;
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({
                errors: (0,_object_spread/* default */.Z)({}, initialCareersState.errors)
            }, key, value));
        });
    }, []);
    var handleRadioButtonChange = (0,react.useCallback)(function(name, value) {
        var key = name;
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({}, key, value));
        });
    }, []);
    var handleSubmit = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            if (!formIsValid()) {
                return [
                    2
                ];
            }
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    isLoading: true
                });
            });
            CareerService_CareerService.sendJobApplication({
                name: state.name,
                email: state.email,
                phone_number: state.phoneNumber,
                country: state.country,
                comment: state.comment,
                experince: state.experince
            }).then(function() {
                setState(function(state) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                        success: true,
                        isLoading: false
                    });
                });
            }).catch(function() {
                setState(function(state) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                        isLoading: false
                    });
                });
            });
            return [
                2
            ];
        });
    }), [
        formIsValid,
        state.comment,
        state.country,
        state.email,
        state.experince,
        state.name,
        state.phoneNumber
    ]);
    var experienced_travel_agent_text = (0,useLocalised/* default */.Z)(translationKeys.experienced_travel_agent);
    var new_travel_agent_text = (0,useLocalised/* default */.Z)(translationKeys.new_travel_agent);
    var radioButtonOptions = (0,react.useMemo)(function() {
        return [
            {
                value: "experienced",
                label: experienced_travel_agent_text
            },
            {
                value: "new",
                label: new_travel_agent_text
            }
        ];
    }, [
        experienced_travel_agent_text,
        new_travel_agent_text
    ]);
    var countryCodeOptions = (0,react.useMemo)(function() {
        return countryCodes.map(function(countryCodes) {
            return {
                value: countryCodes.id.toString(),
                name: countryCodes.name
            };
        });
    }, [
        countryCodes
    ]);
    (0,react.useEffect)(function() {
        if (state.country || countryCodes.length === 0) {
            return;
        }
        var GBCode = countryCodes.find(function(param) {
            var _$name = param.name;
            return _$name === "United Kingdom";
        });
        if (GBCode !== undefined) {
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    country: "".concat(GBCode.name)
                });
            });
            return;
        }
        setState(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                countryCode: "".concat(countryCodes[0].id)
            });
        });
    }, [
        countryCodes,
        setState,
        state.country
    ]);
    var country_code_text = (0,useLocalised/* default */.Z)(translationKeys.country_code);
    var email_text = (0,useLocalised/* default */.Z)(translationKeys.email);
    var name_is_required_text = (0,useLocalised/* default */.Z)(translationKeys.name_is_required);
    var name_text = (0,useLocalised/* default */.Z)(translationKeys.name);
    var submit_text = (0,useLocalised/* default */.Z)(translationKeys.submit);
    var phone_number_text = (0,useLocalised/* default */.Z)(translationKeys.phone_number);
    var email_address_required_text = (0,useLocalised/* default */.Z)(translationKeys.email_address_required);
    var phone_number_required_text = (0,useLocalised/* default */.Z)(translationKeys.phone_number_required);
    var any_additional_comments_text = (0,useLocalised/* default */.Z)(translationKeys.any_additional_comments);
    var apply_text = (0,useLocalised/* default */.Z)(translationKeys.apply);
    var thank_you_text = (0,useLocalised/* default */.Z)(translationKeys.thank_you);
    var job_application_sent_success_message_text = (0,useLocalised/* default */.Z)(translationKeys.job_application_sent_success_message);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "career-form-container",
        children: [
            state.success && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "form-title",
                        children: thank_you_text
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "form-success-message",
                        children: job_application_sent_success_message_text
                    })
                ]
            }),
            !state.success && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "form-title",
                        children: apply_text
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        ref: function(instance) {
                            return giveRef(instance, "name");
                        },
                        label: name_text,
                        type: "text",
                        name: "name",
                        value: state.name,
                        onChange: handleTextChange,
                        error: state.errors.name,
                        helperText: state.errors.name && name_is_required_text,
                        hasErrorMessage: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        ref: function(instance) {
                            return giveRef(instance, "phoneNumber");
                        },
                        label: phone_number_text,
                        type: "text",
                        name: "phoneNumber",
                        value: state.phoneNumber,
                        onChange: handleTextChange,
                        error: state.errors.phoneNumber,
                        helperText: state.errors.phoneNumber && phone_number_required_text,
                        hasErrorMessage: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        ref: function(instance) {
                            return giveRef(instance, "email");
                        },
                        label: email_text,
                        type: "email",
                        name: "email",
                        value: state.email,
                        onChange: handleTextChange,
                        error: state.errors.email,
                        helperText: state.errors.email && email_address_required_text,
                        hasErrorMessage: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                        label: country_code_text,
                        value: state.country,
                        name: "country",
                        onChange: handleSelectChange,
                        options: countryCodeOptions
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                        name: "experince",
                        options: radioButtonOptions,
                        value: state.experince,
                        onRadioButtonClick: handleRadioButtonChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        label: any_additional_comments_text,
                        type: "text",
                        name: "comment",
                        value: state.comment,
                        onChange: handleTextChange,
                        multiline: true,
                        rows: 4
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "form-submit",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                            onClick: handleSubmit,
                            title: submit_text,
                            className: "form-submit_button",
                            isLoading: state.isLoading
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CareerForm = (CareerForm);

// EXTERNAL MODULE: ./blocks/CareerListSection/components/text-bullets/TextBullets.module.scss
var TextBullets_module = __webpack_require__(86828);
var TextBullets_module_default = /*#__PURE__*/__webpack_require__.n(TextBullets_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./blocks/CareerListSection/components/text-bullets/TextBullets.tsx




var TextBullet = function(param) {
    var content = param.content, _separator = param.separator, separator = _separator === void 0 ? "<br />" : _separator, _bulletStyle = param.bulletStyle, bulletStyle = _bulletStyle === void 0 ? "dot" : _bulletStyle, _className = param.className, className = _className === void 0 ? "" : _className, _itemClassName = param.itemClassName, itemClassName = _itemClassName === void 0 ? "" : _itemClassName, _bulletClassName = param.bulletClassName, bulletClassName = _bulletClassName === void 0 ? "" : _bulletClassName;
    var bulletStyles = {
        dot: "•",
        dash: "–",
        arrow: "→",
        star: "★",
        check: "✓",
        number: null
    };
    var items = content.split(separator).map(function(item) {
        return item.trim();
    }).filter(function(item) {
        return item.length > 0;
    });
    var getBulletContent = function(index) {
        if (bulletStyle === "number") {
            return "".concat(index + 1, ".");
        }
        return bulletStyles[bulletStyle] || bulletStyles.dot;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: (TextBullets_module_default()).listContainer,
            children: items.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    className: classnames_default()((TextBullets_module_default()).item, itemClassName),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: bulletClassName,
                            children: getBulletContent(index)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: item
                        })
                    ]
                }, index);
            })
        })
    });
};
/* harmony default export */ var TextBullets = (TextBullet);

;// CONCATENATED MODULE: ./blocks/CareerListSection/components/text-bullets/index.ts


// EXTERNAL MODULE: ./components/text/index.ts
var components_text = __webpack_require__(22538);
;// CONCATENATED MODULE: ./blocks/CareerListSection/components/CareerAccordion.tsx






var CareerAccordion = function(param) {
    var countryCodes = param.countryCodes, career = param.career;
    var introduction = career.introduction, description = career.description, requirements = career.requirements, hasForm = career.hasForm, subheading = career.subheading, secondSubheading = career.secondSubheading, contact = career.contact;
    var job_position_instruction_text = (0,useLocalised/* default */.Z)(translationKeys.job_position_instruction);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "accordion-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "accordion-container__left",
                children: [
                    introduction && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                        color: "grey-dark",
                        children: introduction
                    }),
                    description && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                color: "grey-dark",
                                weight: "demiBold",
                                className: "career-description-title",
                                children: subheading
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBullets, {
                                className: "career-description-list",
                                content: description
                            })
                        ]
                    }),
                    requirements && requirements.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                color: "grey-dark",
                                weight: "demiBold",
                                className: "career-description-title",
                                children: secondSubheading
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBullets, {
                                className: "career-requirement-list",
                                content: requirements
                            })
                        ]
                    }),
                    !hasForm && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "career-instruction-text",
                        children: [
                            "".concat(job_position_instruction_text, " "),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "career-instruction-text__link",
                                href: "mailto:".concat(contact),
                                children: contact
                            })
                        ]
                    })
                ]
            }),
            hasForm && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "accordion-container__right",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CareerForm, {
                    countryCodes: countryCodes
                })
            })
        ]
    });
};
/* harmony default export */ var components_CareerAccordion = (CareerAccordion);

// EXTERNAL MODULE: ./components/accordion-list/index.ts + 5 modules
var accordion_list = __webpack_require__(98736);
;// CONCATENATED MODULE: ./blocks/CareerListSection/CareerListSection.tsx






var CareerListSection = function(param) {
    var careers = param.careers, countryCodes = param.countryCodes;
    var current_open_roles_title = (0,useLocalised/* default */.Z)(translationKeys.current_open_roles);
    var join_a_team_redefining_luxury_description = (0,useLocalised/* default */.Z)(translationKeys.join_a_team_redefining_luxury);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "career-list-container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "career-list-container__heading",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                        as: "h1",
                        className: "career-list-container__title",
                        children: current_open_roles_title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                        children: join_a_team_redefining_luxury_description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "career-list",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_list/* default */.Z, {
                    items: careers,
                    getId: function(career) {
                        return String(career.id);
                    },
                    getTitle: function(career) {
                        return career.name;
                    },
                    getContent: function(career) {
                        return [
                            career
                        ];
                    },
                    getChipLabel: function(career) {
                        return career.location;
                    },
                    withLabel: true,
                    renderContent: function(career) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CareerAccordion, {
                            career: career,
                            countryCodes: countryCodes
                        }, career.id);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var CareerListSection_CareerListSection = (CareerListSection);

// EXTERNAL MODULE: ./blocks/Layouts/GlobalLayout.tsx + 3 modules
var GlobalLayout = __webpack_require__(94082);
// EXTERNAL MODULE: ./blocks/Layouts/page-layout/index.ts + 4 modules
var page_layout = __webpack_require__(80264);
;// CONCATENATED MODULE: ./assets/careers/header-image.jpg
/* harmony default export */ var header_image = ({"src":"/_next/static/media/header-image.1360140c.jpg","height":1250,"width":1920,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAbEAACAgMBAAAAAAAAAAAAAAABAgAEAwYisf/EABUBAQEAAAAAAAAAAAAAAAAAAAME/8QAGBEBAQADAAAAAAAAAAAAAAAAAQAREiH/2gAMAwEAAhEDEQA/AJtLb7NZAqVsTMQO2AJ8iIkgbdZhxf/Z","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./pages/careers/index.tsx







var Careers = function(param) {
    var globalLayoutProps = param.globalLayoutProps, careers = param.careers, pageContent = param.pageContent;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalLayout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, globalLayoutProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(page_layout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageContent), {
            image: header_image,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CareerListSection_CareerListSection, {
                careers: careers,
                countryCodes: globalLayoutProps.countryCodes
            })
        }))
    }));
};
var __N_SSG = true;
/* harmony default export */ var careers = (Careers);


/***/ }),

/***/ 86828:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"TextBullets_listContainer__UxtQo","item":"TextBullets_item__ZvJUy"};

/***/ }),

/***/ 93636:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"radioContainer":"RadioButton_radioContainer__PA7O8","radioButton":"RadioButton_radioButton__Sd7OI","error":"RadioButton_error__n4cO5"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7295,5675,5156,1657,2567,4520,4713,9774,2888,179], function() { return __webpack_exec__(24931); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);